import { ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

export const renderItemContent = (content: ReactNode) => {
  if (typeof content === 'string') {
    return <Translation text={content} span />
  }

  return content
}
